export default __webpack_public_path__ + "static/media/distributon.674fb44f.png";